import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Search from "./pages/Search";
import Dashboard from "./pages/Dashboard";
import SpotDetail from "./pages/SpotDetail";
import BookingSuccess from "./pages/BookingSuccess";
import HostSignup from "./pages/HostSignup";
import DriverWaitlist from "./pages/DriverWaitlist";
import AdminPreLaunch from "./pages/AdminPreLaunch";
import Impressum from "./pages/Impressum";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/search" element={<Search />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/spot/:id" element={<SpotDetail />} />
          <Route path="/booking-success" element={<BookingSuccess />} />
          <Route path="/host-signup" element={<HostSignup />} />
          <Route path="/driver-waitlist" element={<DriverWaitlist />} />
          <Route path="/admin/pre-launch" element={<AdminPreLaunch />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
